import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const NewTableModal = ({ open, onOpenChange, availableTableNumbers, onCreate }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md" data-testid="new-table-modal">
        <DialogHeader>
          <DialogTitle className="text-amber-500 flex items-center gap-2">
            <Plus className="w-5 h-5" />
            Ouvrir une Nouvelle Table
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-slate-400 text-sm mb-4">
            Sélectionnez un numéro de table (1-20) :
          </p>
          <div className="grid grid-cols-5 gap-2">
            {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => {
              const isAvailable = availableTableNumbers.includes(num);
              const isUsed = !isAvailable;
              return (
                <Button
                  key={num}
                  variant={isUsed ? "secondary" : "outline"}
                  size="sm"
                  onClick={() => isAvailable && onCreate(num)}
                  disabled={isUsed}
                  data-testid={`new-table-btn-${num}`}
                  className={
                    isUsed
                      ? "bg-slate-700/50 text-slate-500 cursor-not-allowed"
                      : "border-amber-500/50 text-amber-400 hover:bg-amber-500 hover:text-white"
                  }
                >
                  T{num}
                </Button>
              );
            })}
          </div>
          <div className="flex items-center gap-4 mt-4 pt-4 border-t border-slate-700">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded bg-amber-500/30 border border-amber-500/50" />
              <span className="text-slate-400 text-xs">Disponible</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded bg-slate-700/50" />
              <span className="text-slate-400 text-xs">Occupée</span>
            </div>
          </div>
        </div>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="w-full border-slate-600 text-slate-400"
          data-testid="new-table-cancel-btn"
        >
          Annuler
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default NewTableModal;
